(function () {
  if (window.freeShippingWidgetLoaded) return;
  window.freeShippingWidgetLoaded = true;

  const DEBUG = false;
  const THRESHOLD_DKK = 1100;
  const THRESHOLD_EUR = 395;
  const hostEU = location.hostname.endsWith('.eu');
  const pathEN = location.pathname.startsWith('/en');
  const lang = hostEU ? 'en' : (pathEN ? 'en' : 'da');
  const currency = hostEU ? 'EUR' : 'DKK';

  function formatMoney(v) {
    if (currency === 'DKK') {
      return `${v.toFixed(2).replace('.', ',')} DKK`;
    } else {
      return `${Math.round(v)} EUR`;
    }
  }

  function calcCartValues(cart) {
    let subtotal = 0;
    let qty = 0;

    if (Array.isArray(cart.items)) {
      const valid = cart.items.filter((item) => {
        const title = (item.product_title || item.title || '').toLowerCase();
        return !title.includes('leveringsgebyr');
      });

      subtotal = valid.reduce((sum, i) => sum + i.final_line_price, 0) / 100;
      qty = valid.reduce((cnt, i) => cnt + i.quantity, 0);
    } else {
      subtotal = (cart.items_subtotal_price || 0) / 100;
      qty = cart.item_count || 0;
    }

    if (DEBUG) console.debug('[FSW] Cart values:', { subtotal, qty });
    return { subtotal, qty };
  }

  function render(widget, subtotal, qty) {
    const threshold = hostEU ? THRESHOLD_EUR : THRESHOLD_DKK;
    const missAmt = Math.max(0, threshold - subtotal);
    const missQty = Math.max(0, 3 - qty);
    const qualifies = subtotal >= threshold || (!hostEU && qty >= 3);

    const bar = widget.querySelector('.progress-fill');
    const text = widget.querySelector('.free-shipping-message');
    const barWrap = widget.querySelector('.progress-bar');
    if (!bar || !text || !barWrap) return;

    // Animate progress bar
    bar.style.transition = 'width 0.4s ease';
    bar.style.width = qualifies ? '100%' : `${Math.min(100, (subtotal / threshold) * 100)}%`;
    bar.classList.toggle('complete', qualifies);
    widget.classList.toggle('complete', qualifies);

    // Always show progress bar
    barWrap.style.display = 'block';

    if (hostEU) {
      // EU-domæne: kun subtotal, aldrig antal
      if (qualifies) {
        text.textContent = 'You have unlocked free shipping';
      } else {
        text.textContent = `You are ${formatMoney(missAmt)} away from free shipping`;
      }
      return;
    }

    // DK domæne (da/en)
    const qtyText = lang === 'da'
      ? `${missQty} ${missQty === 1 ? 'produkt' : 'produkter'}`
      : `${missQty} ${missQty === 1 ? 'product' : 'products'}`;
    const amountText = formatMoney(missAmt);

    if (qualifies) {
      text.textContent = lang === 'da'
        ? 'Du har opnået fragt for kun 29 DKK'
        : 'You have unlocked shipping for only 29 DKK';
    } else if (qty === 0) {
      text.textContent = lang === 'da'
        ? 'Billig fragt over 1100 DKK eller ved 3 produkter'
        : 'Low shipping costs over 1100 DKK or with 3 products';
    } else {
      text.textContent = lang === 'da'
        ? `${amountText} eller ${qtyText} fra billig fragt`
        : `${amountText} or ${qtyText} from reduced shipping`;
    }
  }

  function updateWidgets(cart) {
    try {
      const { subtotal, qty } = calcCartValues(cart);
      document.querySelectorAll('.free-shipping-widget').forEach((w) => render(w, subtotal, qty));
    } catch (err) {
      console.error('[FSW] update error', err);
    }
  }

  let cartPromise = null;
  function fetchCart() {
    if (!cartPromise) {
      cartPromise = fetch('/cart.js')
        .then((r) => r.json())
        .catch((e) => console.error('[FSW] fetchCart error', e))
        .finally(() => (cartPromise = null));
    }
    return cartPromise;
  }

  async function refresh() {
    const cart = await fetchCart();
    if (cart) {
      updateWidgets(cart);
      window.dispatchEvent(new CustomEvent('cm:cart', { detail: cart }));
    }
  }

  function waitForWidgetAndInit() {
    const tryInit = () => {
      if (document.querySelector('.free-shipping-widget')) {
        refresh();
        return true;
      }
      return false;
    };

    if (!tryInit()) {
      const observer = new MutationObserver(() => {
        if (tryInit()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForWidgetAndInit);
  } else {
    waitForWidgetAndInit();
  }

  document.addEventListener('theme:cart:change', refresh);
  document.addEventListener('theme:cart-drawer:open', refresh);
  document.addEventListener('page:load', refresh);

  document.body.addEventListener('submit', (e) => {
    if (e.target.matches('form[action^="/cart/add"]')) {
      setTimeout(refresh, 300);
    }
  });

  window.addEventListener('cm:cart', (e) => updateWidgets(e.detail));
})();
